export default __webpack_public_path__ + "static/media/warning--children--g1.be722cbc.png";